import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=39033260&scoped=true"
import script from "./InfoHeader.vue?vue&type=script&lang=js"
export * from "./InfoHeader.vue?vue&type=script&lang=js"
import style0 from "./InfoHeader.vue?vue&type=style&index=0&id=39033260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39033260",
  null
  
)

export default component.exports